import React from 'react';
import classnames from 'classnames';
import { number, node, oneOfType, arrayOf, func } from 'prop-types';

export default function PositionedCard({
    currentPosition,
    targetedPosition,
    nbOfProductCards,
    children,
}) {
    if (
        currentPosition === targetedPosition ||
        (currentPosition < targetedPosition &&
            currentPosition >= nbOfProductCards - 5)
    ) {
        const className = classnames({
            'positioned-card': currentPosition >= nbOfProductCards - 5,
        });
        if (typeof children === 'function') {
            return children({ className });
        }
        return React.cloneElement(children, {
            className,
        });
    }
    return null;
}

PositionedCard.propTypes = {
    targetedPosition: number.isRequired,
    currentPosition: number.isRequired,
    nbOfProductCards: number.isRequired,
    children: oneOfType([node, arrayOf(node), func]),
};

PositionedCard.defaultProp = {
    children: null,
};
